<ng-container *ngIf="data && data.length > 0">
  <h4 *ngIf="title" class="font-semibold mb-3">{{ title | translate }}</h4>
  <mat-paginator
    *ngIf="data.length > pageSize"
    class="mb-4"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons></mat-paginator>
  <table mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true" class="w-full">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="enableSorting && (column.sortable !== false) ? column.key : null">
        {{ column.translationKey | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <app-icon
          *ngIf="column.key === 'activity' && (row.activity | activityIcon) as icon"
          fill="none"
          [iconName]="icon"
          size="md"></app-icon>

        <span *ngIf="column.key !== 'activity' || !(row.activity | activityIcon)">
          {{ row[column.key] }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="getColumnKeys()" class="bg-gray-50"></tr>
    <tr mat-row *matRowDef="let row; columns: getColumnKeys(); let i = index" [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-gray-50'"></tr>
  </table>
</ng-container>
